import creator from './helpers/creator';
import device from './helpers/device';

import Token from './modules/Token';
import Preloader from './modules/Preloader';
import Fetch from './modules/Fetch';
import FetchWithParam from './modules/FetchWithParam';
import Overlay from './modules/Overlay';
import Menu from './modules/Menu';
import Collapsible from './modules/Collapsible';
import LazyVideo from './modules/LazyVideo';
import Rotate from './modules/Rotate';
import Animate from './modules/Animate';
import Video from './modules/Video';
import SwipeCards from './modules/SwipeCards';
import Stepper from './modules/Stepper';
import Credits from './modules/Credits';
import ZoomImage from './modules/ZoomImage';
import UpdateRootVars from './modules/UpdateRootVars';
import Collection from './modules/Collection';
import BoldDate from './modules/BoldDate';
import FetchArt from './modules/FetchArt';
import Filter from './modules/Filter';
import SpaLottie from './modules/SpaLottie';
import { overlayDebugExpose, overlayDebugLog } from './helpers/overlayDebug';

overlayDebugExpose();

document.addEventListener('DOMContentLoaded', () => {
  overlayDebugLog('DOMContentLoaded', {
    overlayDebug: document.documentElement.getAttribute('data-overlay-debug'),
    dataSpa: document.documentElement.getAttribute('data-spa'),
    siteCode: document.documentElement.getAttribute('data-site-code'),
  });
  window.token = new Token();

  if (!document.body.classList.contains('single')) {
    window.fetchwithparam = new FetchWithParam();
    window.fetchdata = new Fetch();
    window.overlay = new Overlay();
    window.preloader = new Preloader();
  }

  window.spaLottie = new SpaLottie();

  window.lazyvideo = new LazyVideo();
  window.updaterootvars = new UpdateRootVars();
  window.rotate = new Rotate();
  window.menu = creator('.js-header', Menu);
  window.collapsible = creator('.js-header', Collapsible);
  window.animate = new Animate();
  if (window.location.href.includes('singleurl')) {
    window.fetchart = new FetchArt();
  }

  window.video = creator('.js-card', Video);
  window.looks = creator('.js-looks', SwipeCards);
  window.collections = creator('.single-collection', Collection);
});

window.addEventListener('fetch:done', () => {
  overlayDebugLog('fetch:done', {
    overlayChildren: document.querySelectorAll('.js-overlay-child').length,
    spaLottieOverlays: document.querySelectorAll('.js-spa-lottie-overlay').length,
  });
  window.stepper = creator('.js-stepper', Stepper);
  window.credits = creator('.js-credits', Credits);
  window.zoomimage = creator('.js-zoom-image', ZoomImage);
  window.bolddate = creator('.js-date', BoldDate);
  window.filters = [];
  document.querySelectorAll('.js-filterable').forEach((tabContent) => {
    window.filters.push(new Filter(tabContent));
  });
});

if (device.isSafari) {
  document.body.classList.add('is-safari');
}
if (device.isChrome) {
  document.body.classList.add('is-chrome');
}
